var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionDotsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 32,
    viewBox: "0 0 8 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 16C7.9375 16.7788 7.70657 17.54 7.27391 18.1876C6.84125 18.8351 6.2263 19.3398 5.50682 19.6378C4.78733 19.9358 3.99563 20.0138 3.23183 19.8618C2.46803 19.7099 1.76644 19.3349 1.21577 18.7842C0.6651 18.2336 0.290089 17.532 0.13816 16.7682C-0.0137696 16.0044 0.0642061 15.2127 0.362226 14.4932C0.660246 13.7737 1.16493 13.1587 1.81244 12.7261C2.45996 12.2934 3.22124 12.0625 4 12.0625C5.04315 12.0662 6.04252 12.4822 6.78014 13.2199C7.51776 13.9575 7.9338 14.9569 7.9375 16ZM4 8.6875C4.77877 8.6875 5.54004 8.45657 6.18756 8.02391C6.83508 7.59126 7.33976 6.9763 7.63778 6.25682C7.9358 5.53733 8.01377 4.74563 7.86184 3.98183C7.70992 3.21803 7.33491 2.51644 6.78424 1.96577C6.23357 1.4151 5.53197 1.04009 4.76817 0.88816C4.00437 0.73623 3.21267 0.814206 2.49319 1.11223C1.7737 1.41025 1.15875 1.91493 0.72609 2.56244C0.293432 3.20996 0.0625021 3.97124 0.0625021 4.75C0.0662078 5.79315 0.482241 6.79252 1.21986 7.53014C1.95749 8.26776 2.95685 8.6838 4 8.6875ZM4 23.3125C3.22124 23.3125 2.45996 23.5434 1.81244 23.9761C1.16493 24.4087 0.660246 25.0237 0.362226 25.7432C0.0642061 26.4627 -0.0137696 27.2544 0.13816 28.0182C0.290089 28.782 0.6651 29.4836 1.21577 30.0342C1.76644 30.5849 2.46803 30.9599 3.23183 31.1118C3.99563 31.2638 4.78733 31.1858 5.50682 30.8878C6.2263 30.5898 6.84125 30.0851 7.27391 29.4376C7.70657 28.79 7.9375 28.0288 7.9375 27.25C7.9338 26.2069 7.51776 25.2075 6.78014 24.4699C6.04252 23.7322 5.04315 23.3162 4 23.3125Z",
    fill: "url(#paint0_linear_4016_355)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4016_355",
    x1: 0.0625,
    y1: 31.1875,
    x2: 14.8205,
    y2: 27.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionDotsSvg);
export default __webpack_public_path__ + "static/media/optionDotsSVG.99060f632f72fd6ada9e2b8e412aa701.svg";
export { ForwardRef as ReactComponent };